import React, { useState } from "react";
import { get } from "lodash";
import { Business, SettingsInputAntennaTwoTone } from "@mui/icons-material";
import { LinearProgress } from "@mui/material";
import * as styles from "./index.module.scss";
import Button from "../Button";
import  MapboxAddressInput from "../FindLocationView/address-input";
import GoogleAddressInput from "../FindLocationView/AddressInput";
import { convertMapboxPlaceToUserAddress } from "../../utils/geoLocation";
import { navigateTo } from "../../utils/location";

const OrderAddress = ({
  currentBranch,
  servingOption,
  businessAppConfiguration,
  appStyles,
  T,
  user,
  order,
  onSetAddressClick,
  validatingDelivery,
  deliveryValidationError,
  onClearDeliveryError,
}) => {

  //create state to save selected user address
  const [userAddress, setUserAddress] = useState(get(order, "deliveryAddress"));

  const dontUseMapbox =
  businessAppConfiguration.useGoogleMapsForGeocoding ||
  appStyles.locale !== "en-US";

  const previousAddresses = get(user, "userDetails.data.seenAddresses", []);
  const {shouldAllowInaccurateAddress} = businessAppConfiguration;
  const onSelectedMapboxAddress = (place) => {
    if (onClearDeliveryError) onClearDeliveryError();
    if (place.savedAddress){
      setUserAddress({
          ..._.pick(place, [
            "geoPoint",
            "zipCode",
            "city",
            "number",
            "street",
            "state",
            "description",
            "apartment",
            "floor",
            "entrance",
            "comments",
          ]),
          isGeometricCenter: true,
        });
      }else{
        setUserAddress(convertMapboxPlaceToUserAddress(place));
      }
  };

  const buttonEnabled = get(userAddress, "geoPoint") && !validatingDelivery;
  return (
    <React.Fragment>
      <Business
        className={styles.icon}
        style={{ color: appStyles.accentColor }}
      />
      <h2 style={{ textAlign: "center", color: appStyles.accentColor }}>
        {T("Delivery ordering")}
      </h2>
      <div
        className={styles.wrapper}
        style={{ color: get(appStyles, "Card.color") }}
      >
        <span style={{ ...appStyles.CardTitle, fontSize: "1.5rem" }}>
          {T("Delivery requires an address")}
        </span>
        <span style={{ marginBottom: 16, marginTop: 6 }}>
          {T(
            "Please enter your address to start ordering"
          )}
        </span>
            <MapboxAddressInput
              usingCurrentLocation={false}
              setUsingCurrentLocation={()=>{}}
              onSelected={onSelectedMapboxAddress}
              placeholder={ T("Enter address with street number")}
              T={T}
              appStyles={appStyles}
              locationBias={_.get(currentBranch, "geoPoint")}
              showLocateMe={false}
              onLocateMeFailure={()=>{}}//this.handleLocateMeError}
              onLocateMeSuccess={()=>{}}//this.handleNewUserCoords}
              autoLocateMeOnMount={false}
              shouldAllowInaccurateAddress={false}
              shouldShowHouseNumberInput={true}
              setAddressWithHouseNumber={(houseNumber) => {}}
              userEnteredInvalidHouseNumber={()=>{}}
              initialValue={null}
              accurateOnly={true}
              onClear={()=>{
                if (onClearDeliveryError) onClearDeliveryError();
                setUserAddress(null);
              }}
              previousAddresses={previousAddresses}
            />
      </div>

      {validatingDelivery && (
        <LinearProgress
          style={{
            color: appStyles.accentColor,
            margin: "10px 0",
          }}
        />
      )}

      {deliveryValidationError && (
        <div style={{ marginTop: 10, textAlign: "center" }}>
          <p style={{ color: "#d32f2f", margin: "0 0 10px 0" }}>
            {T("This location doesn't deliver to the selected address")}
          </p>
          <Button
            appStyles={appStyles}
            centered
            style={{ marginTop: 6 }}
            onClick={() => navigateTo("/find-location")}
          >
            {T("Change Location")}
          </Button>
        </div>
      )}

      {!deliveryValidationError && (
        <Button
          appStyles={appStyles}
          centered
          style={{ marginTop: 16 , ...!buttonEnabled?{ backgroundColor: "#cccccc"} :{} }}
          onClick={buttonEnabled ? () => onSetAddressClick(userAddress) : () => {}}
        >
          {T("Select the address")}
        </Button>
      )}
    </React.Fragment>
  );
};

export default OrderAddress;
